var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutBlob3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 160.33,
    height: 178.471,
    viewBox: "0 0 160.33 178.471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Watercolor blob",
    opacity: 0.8,
    filter: "url(#filter0_f_0_22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M82.7586 19.4213C107.586 12.088 129.655 34.088 137.931 63.4213C146.207 92.7546 143.448 125.755 124.138 144.088C104.828 162.421 71.7241 166.088 49.6552 151.421C27.5862 136.755 16.5517 107.421 22.069 78.088C27.5862 48.7546 57.931 26.7546 82.7586 19.4213Z",
    fill: "url(#paint0_linear_0_22)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_22",
    x: -18,
    y: -13.2454,
    width: 196,
    height: 201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_0_22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_22",
    x1: 20.663,
    y1: 18,
    x2: 121.173,
    y2: 103.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBlob3);
export default __webpack_public_path__ + "static/media/about-blob-3.0699eb612830f5b22aa575cc7a7bdf03.svg";
export { ForwardRef as ReactComponent };